export const delay = (ms, signal) =>
    new Promise((resolve) => {
        if (signal?.aborted) {
            resolve();
            return;
        }

        const id = setTimeout(resolve, ms);
        signal?.addEventListener(
            "abort",
            () => {
                clearTimeout(id);
                resolve();
            },
            { once: true },
        );
    });

const isVisible = (element) => {
    if (!element) {
        return false;
    }

    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
};

export const waitForTarget = (selector, { timeout = 6000, interval = 80, signal } = {}) => {
    if (!selector) {
        return Promise.resolve(true);
    }

    return new Promise((resolve) => {
        if (signal?.aborted) {
            resolve(null);
            return;
        }

        const start = Date.now();
        let id = null;

        signal?.addEventListener(
            "abort",
            () => {
                if (id) {
                    clearTimeout(id);
                }
                resolve(null);
            },
            { once: true },
        );

        const tick = () => {
            if (signal?.aborted) {
                resolve(null);
                return;
            }

            const element = document.querySelector(selector);
            if (isVisible(element)) {
                resolve(element);
                return;
            }

            if (Date.now() - start >= timeout) {
                resolve(null);
                return;
            }

            id = setTimeout(tick, interval);
        };

        tick();
    });
};

export const routesMatch = (location, route) => {
    if (!route) {
        return true;
    }

    const url = new URL(route, window.location.origin);
    if (location.pathname !== url.pathname) {
        return false;
    }

    const needed = url.searchParams;
    const current = new URLSearchParams(location.search);

    return Array.from(needed.entries()).every(([key, value]) => current.get(key) === value);
};
